import { useEffect, useState } from "react";

function Cell({ letter, status, animate, isActive }) {
  const [classes, setClasses] = useState("cell");

  useEffect(() => {
    // Animation POP
    if (animate === "pop") {
      setClasses("cell pop");
      setTimeout(() => setClasses("cell"), 150);
    }

    // Animation FLIP
    if (animate === "flip") {
      setClasses("cell flip");
      // Laisser la classe active, pas de reset ici
    }
  }, [animate]);

  const getColor = () => {
    if (status === "correct") return "#4CAF50";
    if (status === "present") return "#FFC107";
    if (status === "absent") return "#757575";
    return "#ddd";
  };

  const getBorder = () => {
    if (isActive === true) return "red";
    return "#ddd";
  };

  return (
    <div
      className={classes}
      style={{
        backgroundColor: getColor(),
        borderColor: getBorder(),
      }}
    >
      {letter}
    </div>
  );
}

export default Cell;